(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  /* Move drawer to <body> to escape any parent stacking context
     (Shrine sections may have transform/sticky that traps position:fixed) */
  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  var body = drawer.querySelector('[data-cart-body]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var countEl = drawer.querySelector('[data-cart-count-drawer]');

  /* Cache: variant_id -> compare_at_price (cents). Populated from Liquid initial data + on-demand fetches. */
  var compareMap = {};
  try {
    var mapEl = drawer.querySelector('[data-cart-compare-map]');
    if (mapEl && mapEl.textContent.trim()) {
      compareMap = JSON.parse(mapEl.textContent);
    }
  } catch (e) {}

  function fetchProductCompare(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        (product.variants || []).forEach(function (v) {
          compareMap[v.id] = v.compare_at_price || v.price;
        });
      })
      .catch(function () {});
  }

  function ensureCompareForItems(items) {
    var missing = items.filter(function (i) { return compareMap[i.variant_id] == null; });
    var handles = {};
    missing.forEach(function (i) { if (i.handle) handles[i.handle] = true; });
    return Promise.all(Object.keys(handles).map(fetchProductCompare));
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      var fmt = (window.theme && window.theme.moneyFormat) || Shopify.money_format || '${{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return '€' + (cents / 100).toFixed(2);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cdl-open');
    fetchCart();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cdl-open');
  }

  function renderCart(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    var mainCount = document.querySelector('[data-cart-count]');
    if (mainCount) {
      mainCount.textContent = cart.item_count;
      if (cart.item_count > 0) mainCount.classList.remove('is-empty');
      else mainCount.classList.add('is-empty');
    }

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cdl__empty">' +
        '<svg width="60" height="60" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M6 8h14l-1.5 11a2 2 0 0 1-2 1.75H9.5a2 2 0 0 1-2-1.75L6 8Z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/>' +
        '<path d="M10 8V6.5a3 3 0 0 1 6 0V8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
        '</svg>' +
        '<p class="cdl__empty-msg">Your cart is empty</p>' +
        '<button type="button" class="cdl__empty-cta" data-cart-close>Continue shopping</button>' +
        '</div>';
      if (foot) foot.hidden = true;
      bindDynamic();
      return;
    }

    var itemsHtml = '<ul class="cdl__items" data-cart-items>';
    cart.items.forEach(function (item) {
      var img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">'
        : '';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cdl__item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      itemsHtml += '<li class="cdl__item" data-cart-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cdl__item-media">' + img + '</a>' +
        '<div class="cdl__item-body">' +
        '<a href="' + item.url + '" class="cdl__item-title">' + escapeHtml(item.product_title) + '</a>' +
        variantLine +
        '<div class="cdl__item-price">' + formatMoney(item.final_price) + '</div>' +
        '<div class="cdl__item-qty">' +
        '<button type="button" class="cdl__qty-btn" data-cart-decrease aria-label="Decrease">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<span class="cdl__qty-val" data-cart-qty-val>' + item.quantity + '</span>' +
        '<button type="button" class="cdl__qty-btn" data-cart-increase aria-label="Increase">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="cdl__item-remove" data-cart-remove aria-label="Remove">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</button>' +
        '</li>';
    });
    itemsHtml += '</ul>';
    body.innerHTML = itemsHtml;

    if (foot) {
      foot.hidden = false;
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);

      var originalRow = foot.querySelector('[data-cart-original-row]');
      var savingsRow = foot.querySelector('[data-cart-savings-row]');
      var originalEl = foot.querySelector('[data-cart-original]');
      var savingsEl = foot.querySelector('[data-cart-savings]');

      /* Compute compare_at total using the map. If any variant is missing, fall back to price. */
      var compareTotal = 0;
      cart.items.forEach(function (item) {
        var cmp = compareMap[item.variant_id];
        if (cmp == null || cmp <= item.price) cmp = item.price;
        compareTotal += cmp * item.quantity;
      });
      var savings = compareTotal - cart.total_price;
      if (savings > 0) {
        if (originalRow) originalRow.hidden = false;
        if (savingsRow) savingsRow.hidden = false;
        if (originalEl) originalEl.textContent = formatMoney(compareTotal);
        if (savingsEl) savingsEl.textContent = '-' + formatMoney(savings);
      } else {
        if (originalRow) originalRow.hidden = true;
        if (savingsRow) savingsRow.hidden = true;
      }
    }
    bindDynamic();
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return ensureCompareForItems(cart.items || []).then(function () { return cart; });
      })
      .then(renderCart)
      .catch(function () {});
  }

  function changeQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return ensureCompareForItems(cart.items || []).then(function () { return cart; });
      })
      .then(renderCart);
  }

  function bindStatic() {
    /* Close buttons + backdrop */
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* Discount apply — redirect to /discount/CODE?redirect=/checkout */
    var discountForm = drawer.querySelector('[data-cart-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = discountForm.querySelector('[data-cart-discount-input]');
        var code = (input.value || '').trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
    }
  }

  function bindDynamic() {
    body.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    body.querySelectorAll('[data-cart-item]').forEach(function (item) {
      var key = item.getAttribute('data-key');
      var qtyEl = item.querySelector('[data-cart-qty-val]');
      var currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var minus = item.querySelector('[data-cart-decrease]');
      var plus = item.querySelector('[data-cart-increase]');
      var remove = item.querySelector('[data-cart-remove]');
      if (minus) minus.addEventListener('click', function () { changeQty(key, Math.max(0, currentQty - 1)); });
      if (plus) plus.addEventListener('click', function () { changeQty(key, currentQty + 1); });
      if (remove) remove.addEventListener('click', function () { changeQty(key, 0); });
    });
  }

  /* Trigger from cart icons */
  function onCartTriggerClick(e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    open();
  }
  document.addEventListener('click', onCartTriggerClick);

  /* Refresh when other components add items */
  document.addEventListener('cart:refresh', function () {
    fetchCart();
    open();
  });

  /* Esc to close */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  bindStatic();
  bindDynamic();
})();
